'use client'

import { useEffect } from 'react'

import { Navigate } from 'react-router-dom'

import { useFetch } from '@marketplace-web/shared/api-client'
import { useLocation } from '@marketplace-web/shared/browser'
import {
  ConversationInitiatorType,
  transformConversationResponse,
  CONVERSATION_URL,
} from '@marketplace-web/domain/conversation-messaging-data'
import { createItemConversationThread } from 'data/api/create-item-conversation-thread'

import { ContentLoader } from '@marketplace-web/shared/ui-helpers'

const FavoritedItemConversationLoader = () => {
  const queryParams = useLocation().searchParams

  const { fetch: createConversation, transformedData: conversation } = useFetch(
    createItemConversationThread,
    response => transformConversationResponse(response.conversation),
  )

  useEffect(() => {
    const createConversationFromNotification = () => {
      const itemId = queryParams.item_id?.toString()
      const receiverId = queryParams.receiver_id?.toString()
      if (itemId && receiverId) {
        createConversation({
          itemId,
          receiverId,
          initiator: ConversationInitiatorType.SellerEntersNotification,
        })
      }
    }

    createConversationFromNotification()
  }, [createConversation, queryParams])

  if (!conversation) return <ContentLoader testId="conversation-page-loader" />

  return <Navigate to={CONVERSATION_URL(conversation.id)} replace />
}

export default FavoritedItemConversationLoader
